import { getDialingCodeList } from "@/api/systemSet"

const state = {
    dialingCodeList: [],
    dialingCodeListLoaded: false
}

const actions = {
    async fetchDialingCodeList({ state, commit, rootGetters }, force = false) {
        if (force || !state.dialingCodeListLoaded) {
            let params = {
                hotelCode: rootGetters.hotelCode
            }
            const res = await getDialingCodeList(params)
            // 接口返回的就是 data 数组
            commit("setDialingCodeList",
                res.data.map(i => ({
                    label: `${i.dialingCodeName} ${i.dialingCode}`,
                    value: i.dialingCode,
                    default: i.default
                }))
            )


        }

        return state.dialingCodeList
    }
}

const mutations = {
    setDialingCodeList(state, list) {
        state.dialingCodeList = list
        state.dialingCodeListLoaded = true
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
